import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { config } from '../../config';

export default function ProfileMedia() {
  const [userPosts, setUserPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const API_BASE = config.apiBase;

  const fetchUserPosts = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE}/posts/get_user_posts.php`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.success) {
        // Normaliser les URLs des médias pour chaque post
        const normalizedPosts = (data.posts || []).map(post => ({
          ...post,
          media_url: config.normalizePostMedia(post.media_url)
        }));
        setUserPosts(normalizedPosts);
      }
    } catch (error) {
      toast.error('Erreur');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id_post) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE}/posts/delete_post.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ id_post })
      });
      const data = await response.json();
      if (data.success) {
        toast.success('Post supprimé');
        fetchUserPosts();
      }
    } catch (error) {
      toast.error('Erreur');
    }
  };

  useEffect(() => { fetchUserPosts(); }, []);

  if (loading) return <div className="p-6 text-center">Chargement...</div>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-primary mb-6">📱 Mes médias et publications</h1>
      {userPosts.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-12 text-center"><div className="text-5xl mb-4">📭</div><p className="text-gray-500">Aucune publication</p></div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {userPosts.map(post => (
            <div key={post.id_post} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition">
              {post.type_media === 'image' && post.media_url && <img src={post.media_url} alt="" className="w-full h-48 object-cover" />}
              {post.type_media === 'video' && post.media_url && <video src={post.media_url} className="w-full h-48 object-cover" />}
              <div className="p-4">
                <p className="text-sm text-gray-600 line-clamp-2">{post.contenu}</p>
                <div className="flex justify-between items-center mt-3">
                  <span className="text-xs text-gray-400">{new Date(post.created_at).toLocaleDateString()}</span>
                  <button onClick={() => handleDelete(post.id_post)} className="text-red-500 text-sm hover:underline">Supprimer</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}